import React, { type ReactElement } from "react";
import { DarkModePageLayout } from "../../components/DarkModePageLayout";

export function CompanionContentLoader(): ReactElement {
  return (
    <DarkModePageLayout>
      {/* Companion Widget Section */}
      <div
        id="companion-widget"
        className="pt-20 pb-60 mx-auto w-full max-w-3xl"
      >
        <div className="flex flex-col gap-y-4 text-white animate-pulse">
          <div className="flex flex-col gap-y-2 items-start">
            {/* Date skeleton */}
            <div className="h-4 bg-white/30 rounded-lg w-32"></div>
            {/* Welcome title skeleton */}
            <div className="h-8 bg-white/30 rounded-lg w-80"></div>
          </div>
          {/* CompanionWidget skeleton */}
          <div className="relative w-3/5 mt-6">
            <div className="w-full rounded-xl border border-white/10 px-4 py-3 bg-white/10 h-[100px]"></div>
            <div className="absolute bottom-4 right-4">
              <div className="h-8 w-8 bg-white/20 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Home Page Content Section */}
      <div
        id="home-page-content"
        className="flex flex-col gap-y-16 mx-auto w-full max-w-3xl animate-pulse"
      >
        {/* Employee NPS Survey skeleton */}
        <div className="bg-white/10 rounded-lg p-6 h-24"></div>

        {/* Upcoming Events skeleton */}
        <div className="space-y-4">
          <div className="h-6 bg-white/30 rounded w-48"></div>
          <div className="bg-white/10 rounded-lg p-6 h-32"></div>
        </div>

        {/* Popular Topics Companion Widget skeleton */}
        <div className="space-y-4">
          <div className="h-6 bg-white/30 rounded w-40"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="bg-white/10 rounded-lg h-32"></div>
            <div className="bg-white/10 rounded-lg h-32"></div>
            <div className="bg-white/10 rounded-lg h-32"></div>
          </div>
        </div>

        {/* Companion Session List Widget skeleton */}
        <div className="space-y-4">
          <div className="h-6 bg-white/30 rounded w-44"></div>
          <div className="space-y-3">
            <div className="bg-white/10 rounded-lg h-16"></div>
            <div className="bg-white/10 rounded-lg h-16"></div>
            <div className="bg-white/10 rounded-lg h-16"></div>
          </div>
        </div>

        {/* Popular Resources skeleton */}
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <div className="h-6 bg-white/30 rounded w-36"></div>
            <div className="h-8 bg-white/30 rounded w-20"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-white/10 rounded-lg h-24"></div>
            <div className="bg-white/10 rounded-lg h-24"></div>
          </div>
        </div>

        {/* Mobile App Downloader skeleton */}
        <div className="bg-white/10 rounded-lg p-6 h-20"></div>
      </div>
    </DarkModePageLayout>
  );
}

export default function CompanionLoader(): ReactElement {
  return <CompanionContentLoader />;
}
